<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Reconciliation Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_data: moment(new Date()).format("DD-MM-YYYY"),
      id: atob(this.$route.params.id),
      total: 0,
    };
  },
  computed: {
    ...mapGetters("sales", ["HoldInvoice"]),
  },
  watch: {
      HoldInvoice(newValue) {
          if(newValue){
              this.calcTot();
          }
      }
  },
  methods: {
    ...mapActions({
      FetchInvoice: "sales/fetchHoldInvoice",
    }),

    calcTot() {
        let x = 0;
        this.HoldInvoice.forEach(invoice => {
            let hh = invoice.items;
            hh.forEach(item => {
                x = x + (parseInt(item.selling)*parseInt(item.quantity));
            })
        });
        alert(x);
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  updated() {
    let total_amount = 0;
    // let total_paid = 0;
    if(this.HoldInvoice.items){
      this.HoldInvoice.items.forEach((item)=>{
        total_amount = total_amount+parseInt(item.selling*item.quantity);
      });
      this.total = total_amount;
      // this.SalesAnalysis.forEach((item)=>{
      //   total_paid = total_paid+parseInt(item.sale.paid);
      // });
      // this.total_paid = total_paid;
    }
    // setTimeout(() => {
    //   window.print();
    // }, 1000);
  },
  created() {
    this.FetchInvoice(this.id);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}
</style>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print Invoice</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-left"></i> Go Back
          </button>
        </div>

        <div class="bg-white">
          <div class="print-font">
              <b-spinner
                v-if="!HoldInvoice"
                class="m-0"
                variant="primary"
                role="status"
              ></b-spinner>
              <div class="mt-3" v-else>
                  <center>
                    <strong style="font-size: calc(1.2671875rem + 0.20625vw)">
                    {{
                      HoldInvoice ? HoldInvoice.branch.name : "---"
                    }}</strong
                  >
                  <p>
                    <span>
                      {{
                        HoldInvoice ? HoldInvoice.branch.address : "---"
                      }}</span
                    >
                    <br />
                    <strong>Tel: </strong
                    >{{
                      HoldInvoice
                        ? "+256" + HoldInvoice.branch.phone1
                        : "---"
                    }}
                    <br />
                    <strong>Email: </strong
                    >{{ HoldInvoice ? HoldInvoice.branch.email : "---" }}
                  </p>
                  </center>
              </div>
            <!-- <hr style="border-style: dashed; width: 97%" /> -->
            <h5
              style="
                text-align: center;
                font-weight: bold;
                font-family: Courier New, Courier, Lucida Sans Typewriter,
                  Lucida Typewriter, monospace;
              "
            >
              <span>
                <strong>
                  ORDER INVOICE
                  <br />
                  Served By <br />
                  {{ HoldInvoice?HoldInvoice.user:"---" }} at
                  {{ HoldInvoice?HoldInvoice.dateAdded:"---" }}</strong
                ></span
              >
              <br />
            </h5>
            <h4><b>Ordered Items</b></h4>
            
            <center>
              <table width="100%" style="font-size:15px" class="mTable">
                <thead>
                  <tr width="100%" >
                    <!-- <th width="5%">S/N</th> -->
                    <th width="35%" >Item</th>
                    <th width="20%" >Qty</th>
                    <th width="20%" >Unit Price</th>
                    <th width="20%" >Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(record, r) in HoldInvoice?HoldInvoice.items:'---'" :key="r">
                    <!-- <td width="5%">{{ r + 1 }}</td> -->
                    <td width="35%" >{{ record.name }}</td>
                    <td width="20%" >{{ record.quantity }}{{ record.unit }}</td>
                    <td width="20%" >{{ thousandSeperator(record.selling) }}</td>
                    <td width="20%" >{{ thousandSeperator(record.selling*record.quantity) }}</td>
                  </tr>
                  <tr>
                    <td width="20%" align="center"><h5><b>Total</b></h5></td>
                    <td width="20%" ></td>
                    <td width="20%" ></td>
                    <td width="20%"><h5><b>{{ thousandSeperator(total) }}</b></h5></td>
                  </tr>
                </tbody>
              </table>
            </center>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <!-- end row -->
  </Layout>
</template>
<style scoped>
    table,th{
        border: 1px solid grey;
    }
    td{
        border: 1px dotted grey;
    }
    .btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>